/* ==========================================================================
   Bike Match — score de compatibilité sur les product cards de collection.
   Lit le profil enregistré par la modal « Trouvez le vélo idéal »
   (sessionStorage: loewi_bike_profile) et affiche, en haut à gauche de chaque
   card, un badge « Recommandé à X% ». Le meilleur match reçoit une bordure verte.
   Recalculé à chaque re-render AJAX des filtres (MutationObserver).
   ========================================================================== */
(function () {
  'use strict';

  var KEY = 'loewi_bike_profile';

  // Ordre des tranches de taille (pour mesurer la proximité) — cf. facets.js
  var BRACKETS = ['-150cm', '150cm - 160cm', '160cm - 170cm', '170cm - 180cm', '180cm - 190cm', '+190cm'];
  var BRACKETS_LC = BRACKETS.map(function (b) { return b.toLowerCase(); });

  function getProfile() {
    try {
      return JSON.parse(sessionStorage.getItem(KEY));
    } catch (e) {
      return null;
    }
  }

  // --- Sous-scores par critère (retourne null si le critère n'est pas fourni) ---
  function typeSub(profile, card) {
    if (!profile.types || !profile.types.length) return null;
    var t = (card.getAttribute('data-product-type') || '').trim().toLowerCase();
    return profile.types.indexOf(t) > -1 ? 1 : 0;
  }

  function heightSub(profile, card) {
    if (!profile.bracket) return null;
    var cardB = (card.getAttribute('data-product-taille') || '').trim().toLowerCase();
    if (!cardB) return 0.5;
    // « Taille unique » = s'adapte à toutes les morphologies → très bon match
    if (cardB.indexOf('unique') > -1) return 0.9;
    var pb = profile.bracket.toLowerCase();
    if (cardB === pb) return 1;
    var ci = BRACKETS_LC.indexOf(cardB);
    var pi = BRACKETS_LC.indexOf(pb);
    if (ci < 0 || pi < 0) return 0.4;
    var d = Math.abs(ci - pi);
    if (d === 1) return 0.6;
    if (d === 2) return 0.3;
    return 0.1;
  }

  function priceSub(profile, card) {
    if (!profile.price) return null;
    var cents = parseFloat(card.getAttribute('data-product-price'));
    if (isNaN(cents)) return 0.5;
    var euros = cents / 100;
    var lo = profile.price.min != null ? profile.price.min : 0;
    var hi = profile.price.max != null ? profile.price.max : Infinity;
    if (euros >= lo && euros <= hi) return 1;
    var dist = euros < lo ? lo - euros : euros - hi;
    var spread = (profile.price.max != null && profile.price.min != null)
      ? (profile.price.max - profile.price.min)
      : 1000;
    return Math.max(0, (1 - Math.min(1, dist / spread)) * 0.7);
  }

  // Score global 0..100 (mappé sur 60..99 pour rester positif)
  function scoreCard(profile, card) {
    var subs = [
      { w: 0.45, s: typeSub(profile, card) },
      { w: 0.35, s: heightSub(profile, card) },
      { w: 0.20, s: priceSub(profile, card) }
    ];
    var tot = 0, wsum = 0;
    for (var i = 0; i < subs.length; i++) {
      if (subs[i].s != null) {
        tot += subs[i].w * subs[i].s;
        wsum += subs[i].w;
      }
    }
    if (wsum === 0) return null;
    return Math.round(60 + (tot / wsum) * 39);
  }

  function ensureContainer(card) {
    var c = card.querySelector('.product-card--label-container');
    if (!c) {
      c = document.createElement('div');
      c.className = 'product-card--label-container';
      var fig = card.querySelector('.product-featured-image') || card;
      fig.insertBefore(c, fig.firstChild);
    }
    return c;
  }

  function applyMatches() {
    var profile = getProfile();
    if (!profile) return;

    var grid = document.getElementById('product-grid') || document;
    var cards = grid.querySelectorAll('product-card.product-card');
    if (!cards.length) {
      console.info('[BikeMatch] profil trouvé mais aucune product-card sur la page.');
      return;
    }
    var best = null, bestScore = -1;
    var scored = [];

    cards.forEach(function (card) {
      card.classList.remove('product-card--best-match');
      var existing = card.querySelector('.product-card--label-match');
      var score = scoreCard(profile, card);

      if (score == null) {
        if (existing) existing.remove();
        return;
      }

      scored.push({ card: card, score: score });

      var badgeEl;
      if (existing) {
        existing.textContent = 'Recommandé à ' + score + '%';
        badgeEl = existing;
      } else {
        badgeEl = document.createElement('div');
        badgeEl.className = 'product-card--label product-card--label-match';
        badgeEl.textContent = 'Recommandé à ' + score + '%';
        var cont = ensureContainer(card);
        cont.insertBefore(badgeEl, cont.firstChild);
      }

      // « Match uniquement » : masquer les autres badges de la card
      var container = badgeEl.parentElement;
      if (container) {
        var labels = container.querySelectorAll('.product-card--label');
        for (var j = 0; j < labels.length; j++) {
          if (labels[j] !== badgeEl) labels[j].style.display = 'none';
        }
      }

      if (score > bestScore) {
        bestScore = score;
        best = card;
      }
    });

    if (best) {
      best.classList.add('product-card--best-match');
      console.info('[BikeMatch] ' + cards.length + ' cards notées, meilleur match ' + bestScore + '%.');
    }

    // Tri : les vélos les mieux notés remontent — MAIS en préservant la position
    // des blocs non-produits (promotions, bannières) : on ne trie que les
    // emplacements de cartes, les autres enfants restent à leur index d'origine.
    // (L'observer est déconnecté pendant l'application → pas de boucle.)
    if (grid.id === 'product-grid' && scored.length > 1) {
      var scoreByCard = new Map();
      scored.forEach(function (o) { scoreByCard.set(o.card, o.score); });

      function isCardItem(child) { return !!child.querySelector('product-card.product-card'); }
      function scoreOfItem(child) {
        var c = child.querySelector('product-card.product-card');
        return c && scoreByCard.has(c) ? scoreByCard.get(c) : -1;
      }

      var children = Array.prototype.slice.call(grid.children);
      var cardItems = children.filter(isCardItem);
      var sorted = cardItems
        .map(function (el, i) { return { el: el, s: scoreOfItem(el), i: i }; })
        .sort(function (a, b) { return b.s - a.s || a.i - b.i; }) // décroissant, stable
        .map(function (o) { return o.el; });

      var si = 0;
      var desired = children.map(function (child) {
        return isCardItem(child) ? sorted[si++] : child;
      });

      // Idempotent : on ne touche au DOM QUE si l'ordre change réellement.
      // Évite les réorganisations (et le clignotement) à chaque run() redondant.
      var changed = desired.some(function (el, idx) { return el !== children[idx]; });
      if (changed) {
        desired.forEach(function (el) { grid.appendChild(el); });
      }
    }
  }

  // Sortie du mode reco : quand l'utilisateur efface les filtres, on retire le
  // profil (badges + tri disparaissent) et on nettoie tout de suite l'affichage.
  function exitRecoMode() {
    try { sessionStorage.removeItem(KEY); } catch (e) {}
    document.querySelectorAll('.product-card--best-match').forEach(function (c) {
      c.classList.remove('product-card--best-match');
    });
    document.querySelectorAll('.product-card--label-match').forEach(function (b) {
      b.remove();
    });
  }

  function init() {
    var profile = getProfile();
    if (!profile) {
      console.info('[BikeMatch] aucun profil en session — lance une recherche depuis le hero.');
      return;
    }

    // « Effacer tout » (desktop .facets-sticky-clear / mobile .mobile-filters-clear)
    // → on quitte le mode recommandations. Capture pour passer avant le handler
    // facets (AJAX renderPage) ou la navigation du lien mobile.
    document.addEventListener('click', function (e) {
      if (e.target.closest('.facets-sticky-clear, .mobile-filters-clear')) {
        exitRecoMode();
      }
    }, true);

    var container = document.getElementById('ProductGridContainer');
    var obs = null;
    var timer;

    function run() {
      if (obs) obs.disconnect();
      applyMatches();
      // On se reconnecte après nos propres mutations pour éviter toute boucle
      if (obs && container) obs.observe(container, { childList: true, subtree: true });
    }

    function schedule() {
      clearTimeout(timer);
      timer = setTimeout(run, 40);
    }

    run();

    // facets.js remplace #ProductGridContainer.innerHTML (ce qui efface nos badges)
    // et émet « productsRendered » : on réapplique à ce moment-là.
    window.addEventListener('productsRendered', schedule);

    // Filet de sécurité : certains scripts/apps reconstruisent la grille juste
    // après le chargement, ce qui masquait nos badges « aussitôt apparus ».
    [150, 500, 1200].forEach(function (d) { setTimeout(run, d); });

    if (container && window.MutationObserver) {
      obs = new MutationObserver(schedule);
      obs.observe(container, { childList: true, subtree: true });
    }
  }

  // Le script est en defer mais on couvre le cas où le DOM est déjà prêt
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
